<template>
    <section>
        <ds-modal
            :is-open="isOpen"
            :size="modalSize"
            data-qa="createReferralModal"
            show-close
            dialog
            :title="isEdit ? 'Edit referral info': 'Add referral'"
            @close="modalClose"
        >
            <div>
                <ds-select-field
                    v-model="referralPartner"
                    :options="partnersList"
                    name="referralPartner"
                    label="Referral Partner"
                    data-qa="partners-list"
                    required
                />

                <ds-date-picker
                    v-model="dateSet"
                    label="Date Set"
                />

                <ds-text-area-field
                    v-model="source"
                    label="Description"
                />

                <div class="referral-buttons">
                    <div v-if="isEdit">
                        <ds-filled-button
                            class="save-button"
                            data-qa="update-referral"
                            @click="updateReferral"
                        >
                            Save
                        </ds-filled-button>

                        <ds-outline-button
                            destructive
                            data-qa="remove-referral"
                            @click="removeReferral"
                        >
                            Delete
                        </ds-outline-button>
                    </div>

                    <div v-else>
                        <ds-filled-button
                            class="save-button"
                            :disabled="disableSave"
                            data-qa="save-referral"
                            @click="saveReferral"
                        >
                            Save
                        </ds-filled-button>

                        <ds-outline-button
                            data-qa="cancel-referral"
                            @click="modalClose"
                        >
                            Cancel
                        </ds-outline-button>
                    </div>
                </div>
            </div>
        </ds-modal>
    </section>
</template>
<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: {
        contact: Object,
    },

    data() {
        return {
            isOpen: false,
            modalSize: 'med',
            referralPartner: '',
            dateSet: '',
            partnersList: [],
            source: '',
            url: '/app/affiliate/getReferral',
            isEdit: false,
            referralId: Number,
            affiliateId: Number,
            date: new Date(),
        };
    },

    created() {
        this.loadPartnersList();
    },

    computed: {
        disableSave() {
            return !this.referralPartner;
        },
    },

    methods: {
        showModal(item) {
            if (item !== null) {
                this.isEdit = true;
                this.referralPartner = item.referralPartner;
                this.dateSet = item.dateSet;
                this.source = item.source;
                this.referralId = item.id;
                this.affiliateId = item.affiliatedId;
            } else {
                this.referralPartner = '';
                this.dateSet = this.date;
                this.source = '';
            }
            this.isOpen = true;
        },

        modalClose() {
            this.isOpen = false;
            this.isEdit = false;
        },

        dateFormatDate(date, format = 'YYYY-MM-DD') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        saveReferral() {
            this.$emit('saveReferral', {
                source: this.source,
                affiliateId: this.referralPartner.value,
                contactId: this.contact.id,
                dateSet: this.dateSet,
            });
        },

        updateReferral() {
            const setDate = this.dateFormatDate(this.dateSet);

            this.$emit('updateReferral', {
                id: this.referralId,
                source: this.source,
                affiliateId: this.referralPartner.value ? this.referralPartner.value : this.affiliateId,
                contactId: this.contact.id,
                dateSet: setDate,
            });
        },

        removeReferral() {
            this.$emit('removeReferral', this.referralId);
        },

        async loadPartnersList() {
            this.currentReferalPartner = [];

            try {
                const response = await axios.get('/app/affiliate/partnersList');

                this.partnersList = response.data;
                this.partnersList = Object.keys(this.partnersList).map((key) => {
                    return { value: key, label: this.partnersList[key] };
                });
            } catch (error) {
                this.$error({ message: 'Unable to get contact referral partners for this contact' });
            }
        },
    },
};

</script>

<style lang="scss" scoped>
.referral-buttons {
    display: flex;

    .save-button {
        margin-right: $spacing-200;
    }
}
</style>
